/**
 * Initialization swiper
 */
import Swiper from "swiper";
import {Autoplay, Controller, Navigation, Pagination, Thumbs} from "swiper/modules";

const homeSlider = new Swiper('.swiper-reviews', {
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    },
    autoplay: {
        delay: 4000,
    },
    slidesPerView: 1,
    loop: true,
    initialSlide: 0,
    centeredSlides: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    modules: [Controller, Navigation, Autoplay, Pagination]
});
